import axiosInstance from './axiosInstance';

/**
 * POST /api/admin/login
 * Backend: app.use('/api/admin', adminRoutes) → router.post('/login', ...)
 * @param {string} email
 * @param {string} password
 * @returns {{ token: string, user/admin: object }}
 */
export const loginAdmin = async (email, password) => {
    const response = await axiosInstance.post('/admin/login', { email, password });
    return response.data;
};

/**
 * POST /api/admin/forgot-password
 * Sends a 6-digit OTP to the provided email.
 * @param {string} email
 */
export const forgotPassword = async (email) => {
    const response = await axiosInstance.post('/admin/forgot-password', { email });
    return response.data;
};

/**
 * POST /api/admin/reset-password
 * Resets the password using the OTP received via email.
 * @param {string} email
 * @param {string} otp        - 6-digit OTP
 * @param {string} newPassword - min 6 characters
 */
export const resetPassword = async (email, otp, newPassword) => {
    const response = await axiosInstance.post('/admin/reset-password', {
        email,
        otp,
        newPassword,
    });
    return response.data;
};

/**
 * GET /api/admin/profile
 * Protected — requires valid Bearer token (auto-attached by axiosInstance interceptor).
 * @returns {{ id, email, fullName, role, createdAt }}
 */
export const getAdminProfile = async () => {
    const response = await axiosInstance.get('/admin/profile');
    return response.data;
};

/**
 * PUT /api/admin/change-password
 * Protected — requires valid Bearer token.
 * @param {string} currentPassword
 * @param {string} newPassword
 */
export const changePassword = async (currentPassword, newPassword) => {
    const response = await axiosInstance.put('/admin/change-password', {
        currentPassword,
        newPassword,
    });
    return response.data;
};
